import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import "./App.css";
import heroImg from "./assets/hero.jpg";
import deadLeadsImg from "./assets/dead-leads.jpg";
import teamImg from "./assets/team.jpg";
import appointmentsImg from "./assets/appointments.jpg";
import gameshowImg from "./assets/gameshow.jpg";
import logo from "./assets/logo.png";
import catImg from "./assets/zombies2.png";
// import zombiesImg from "./assets/zombies.png";
// import catDock from "./assets/cat-dock.png";
import Solutions from "./Solutions";
import DemoSection from "./DemoSection";

function Header() {
  const [mobileNavOpen, setMobileNavOpen] = React.useState(false);
  return (
    <header className='main-header'>
      <div className='header-inner'>
        <div className='logo-hamburger-row'>
          <img src={logo} alt='Logo' className='logo-img invert' />
          <button
            className={`hamburger-menu${mobileNavOpen ? " open" : ""}`}
            aria-label='Open navigation menu'
            onClick={() => setMobileNavOpen((open) => !open)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
        <nav className='main-nav'>
          <ul>
            <li>
              <a href='#how-it-works'>ABOUT</a>
            </li>
            <li>
              <a href='#services'>SERVICES</a>
            </li>
            <li>
              <a href='#contact'>
                <button className='contact-btn'>CONTACT</button>
              </a>
            </li>
          </ul>
        </nav>
      </div>
      {mobileNavOpen && (
        <nav className='mobile-nav'>
          <ul>
            <li>
              <a href='#how-it-works' onClick={() => setMobileNavOpen(false)}>
                ABOUT
              </a>
            </li>
            <li>
              <a href='#services' onClick={() => setMobileNavOpen(false)}>
                SERVICES
              </a>
            </li>
            <li>
              <Link to='/more-services' onClick={() => setMobileNavOpen(false)}>
                MORE SERVICES
              </Link>
            </li>
            <li>
              <a href='#contact' onClick={() => setMobileNavOpen(false)}>
                <button className='contact-btn'>CONTACT</button>
              </a>
            </li>
          </ul>
        </nav>
      )}
      <div className='giant-hero-img'>
        {/* <img src={heroImg} alt='Hero' className='hero-image' /> */}
      </div>
    </header>
  );
}

function MoreServicesPage() {
  return (
    <>
      <Header />
      <Solutions />
      <DemoSection />
    </>
  );
}

function Section({ id, title }) {
  if (id === "about") {
    return (
      <section id={id} className='page-section'>
        <div className='section-content'>
          <p>
            9 LIVES is an AI-powered marketing agency specializing in lead
            reactivation, automation, and appointment booking. We help
            businesses turn their old, cold leads into new revenue—risk free.
          </p>
          <ul>
            <li>Founded by experts in AI and sales automation</li>
            <li>Zero upfront cost, pay only for results</li>
          </ul>
        </div>
      </section>
    );
  } else if (id === "services") {
    return (
      <section id='services' className='page-section'>
        <div className='services-cards'>
          <div className='transformation-card rounded-card'>
            <img
              src={heroImg}
              alt='Hero on Pile of Money'
              className='transformation-img rounded-img'
            />
            <h3>Lead Reactivation</h3>
            <p>
              <strong>Unlock Hidden Revenue—Guaranteed</strong>
              <br />
              Using our exclusive 9-Lives Reactivation Engine, we turn your
              coldest leads into fresh opportunities. Proprietary AI sequences,
              proven to revive even the oldest contacts, all with zero risk.
            </p>
          </div>
          <div className='transformation-card rounded-card'>
            <img
              src={appointmentsImg}
              alt='Scientist Zapping Cards'
              className='transformation-img rounded-img'
            />
            <h3>AI Automation</h3>
            <p>
              <strong>Custom AI Outreach, Tailored for You</strong>
              <br />
              Our 9L Method combines automated follow-ups, lead scoring, and
              conversational AI. Each campaign is tailored to your industry, so
              your leads get real conversations—not canned spam.
            </p>
          </div>
          <div className='transformation-card rounded-card'>
            <img
              src={gameshowImg}
              alt='Game Show Host'
              className='transformation-img rounded-img'
            />
            <h3>Appointment Booking</h3>
            <p>
              <strong>Results-Only Pricing—You Win or You Don't Pay</strong>
              <br />
              Booked calls land directly on your calendar, ready to close. We're
              so confident, you pay only for actual appointments—no upfront
              costs, no contracts, just booked business or it's free.
            </p>
          </div>
        </div>
      </section>
    );
  }
  return null;
}

function ParallaxText() {
  // Only show on desktop/tablet
  const [isMobile, setIsMobile] = React.useState(false);
  const ref = React.useRef();

  React.useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 900);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  React.useEffect(() => {
    if (isMobile) return;
    const handleScroll = () => {
      if (!ref.current) return;
      const rect = ref.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const center = rect.top + rect.height / 2 - windowHeight / 2;
      const max = windowHeight / 2 + rect.height / 2;
      const percent = Math.max(-1, Math.min(1, center / max));
      ref.current.style.transform = `translateY(${percent * 120}px)`;
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isMobile, ref]);

  if (isMobile) return null;

  return (
    <div
      ref={ref}
      className='parallax-text-section'
      style={{
        width: "100%",
        padding: "64px 0 48px 0",
        background: "#fff",
        textAlign: "center",
        overflow: "hidden",
        cursor: "pointer",
        transition: "transform 0.7s cubic-bezier(.4,2,.6,1)",
        willChange: "transform",
      }}
    >
      <h2
        style={{
          fontFamily: "Kanit, Roboto, Arial, sans-serif",
          fontWeight: 900,
          fontSize: "6vw",
          margin: 0,
          letterSpacing: "0.01em",
          color: "#111",
          textTransform: "uppercase",
          lineHeight: 1.05,
          textShadow: "0 8px 32px rgba(0,0,0,0.10)",
        }}
      >
        AI-POWERED LEAD REVIVAL
        <br />
        <span
          style={{
            fontSize: "2vw",
            fontWeight: 400,
            color: "#e6007a",
            letterSpacing: "0.04em",
            textTransform: "none",
            display: "block",
            marginTop: "16px",
          }}
        >
          Give your pipeline <span style={{ fontWeight: 700 }}>9 LIVES</span>
          —bring back lost revenue with zero risk.
        </span>
      </h2>
    </div>
  );
}

function RoadmapSection() {
  return (
    <section className='roadmap-section'>
      <div className='roadmap-inner'>
        <div className='roadmap-img-col'>
          {/* Replace with your actual image paths */}
          <img
            src={require("./assets/car.png")}
            alt='Car'
            className='roadmap-car-img'
          />
          <img
            src={require("./assets/squiggle.png")}
            alt='Roadmap Path'
            className='roadmap-squiggle'
          />
        </div>
        <div className='roadmap-content-col'>
          <h2>Your roadmap to digital marketing</h2>
          <p>
            For small businesses, the odds can be rough, but we're here to make
            sure you defy them. It's time to break away from the pack, and we'll
            be there every step of the way.
          </p>
        </div>
      </div>
    </section>
  );
}

function FooterSection({ title, children }) {
  const [open, setOpen] = React.useState(false);
  return (
    <div className='footer-section'>
      <button
        className='footer-section-title'
        onClick={() => setOpen((o) => !o)}
      >
        {title}
        <span className='footer-arrow'>{open ? "▲" : "▼"}</span>
      </button>
      <div
        className='footer-section-content'
        style={{ display: open ? "block" : "none" }}
      >
        {children}
      </div>
    </div>
  );
}

function Footer() {
  return (
    <footer className='footer'>
      <div className='footer-inner'>
        <div className='footer-main'>
          <FooterSection title='Services'>
            <ul>
              <li>Lead Reactivation</li>
              <li>AI Automation</li>
              <li>Appointment Booking</li>
            </ul>
          </FooterSection>
          <FooterSection title='About Us'>
            <ul>
              <li>
                <a href='#how-it-works'>How It Works</a>
              </li>
              <li>
                <a href='#services'>Our Services</a>
              </li>
              <li>
                <a href='#contact'>Contact</a>
              </li>
            </ul>
          </FooterSection>
          <FooterSection title='Contact Us'>
            <div>
              <div>
                Phone: <a href='tel:9546968605'>954-696-8605</a>
              </div>
              <div>
                Email: <a href='mailto:info@9lives.com'>info@9lives.com</a>
              </div>
            </div>
          </FooterSection>
        </div>
        <div className='footer-bottom'>
          <span>9 LIVES © {new Date().getFullYear()}</span>
          <div className='footer-links'>
            <a href='/terms'>Terms</a>
            <a href='/privacy'>Privacy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path='/'
          element={
            <div className='homepage'>
              <Header />
              {/* Hero Section */}
              <header className='hero'>
                <div className='hero-content'>
                  <div className='giant-title-row'>
                    <span className='giant-black'>9</span>
                    <span className='giant-outline'>LIVES</span>
                  </div>
                  <h1 className='hero-title'>
                    Turn Your Dead Leads Into Booked Calls—With Zero Upfront
                    Cost
                  </h1>
                  <a href='tel:9546968605' className='cta-btn'>
                    CALL NOW
                  </a>
                  <p className='subheadline'>
                    We use AI to revive your old leads and deliver new
                    appointments—only pay for results, no risk.
                  </p>
                </div>
                <div className='hero-image'>
                  <img
                    src={deadLeadsImg}
                    alt='Hero'
                    className='hero-img-main rounded-img'
                  />
                </div>
              </header>

              {/* Marquee Section with Black Background and New Text */}
              <div className='marquee-container inverted'>
                <div className='marquee'>
                  <div className='marquee-content'>
                    {[...Array(5)].map((_, i) => (
                      <React.Fragment key={i}>
                        <span className='giant-title-row'>
                          <span className='giant-black'>9</span>
                          <span className='giant-outline'>LIVES</span>
                        </span>
                        <span className='marquee-text'>
                          <span className='filled'>REVIVE</span>
                          <span className='outline'>YOUR</span>
                          <span className='filled'>LEADS</span>
                        </span>
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              </div>

              {/* How It Works */}
              <section id='how-it-works' className='how-it-works'>
                <h2>How It Works</h2>
                <div className='steps'>
                  <div className='step'>
                    <div className='icon'>📤</div>
                    <h3>Upload Your Old Leads</h3>
                    <p>Send us your list of past leads—no matter how cold.</p>
                  </div>
                  <div className='step'>
                    <div className='icon'>🤖</div>
                    <h3>AI Revives & Nurtures</h3>
                    <p>
                      Our AI reaches out, re-engages, and nurtures your leads
                      automatically.
                    </p>
                  </div>
                  <div className='step'>
                    <div className='icon'>📅</div>
                    <h3>Get Booked Appointments</h3>
                    <p>
                      Warm, ready-to-buy prospects are scheduled directly onto
                      your calendar.
                    </p>
                  </div>
                  <div className='step'>
                    <div className='icon'>💸</div>
                    <h3>Only Pay for Results</h3>
                    <p>
                      You pay only for booked calls—no upfront fees, no risk.
                    </p>
                  </div>
                </div>
              </section>

              {/* Parallax Text Section */}
              <ParallaxText />

              {/* Benefits Section */}
              <section className='benefits-section'>
                <div className='benefits-hero'>
                  <div className='benefits-image-col'>
                    <BenefitsCarousel />
                  </div>
                  <div className='benefits-content-col'>
                    {/* <div className='giant-title-row benefits-title'>
                      <span className='giant-black'>9</span>
                      <span className='giant-outline'>LIVES</span>
                    </div> */}
                    <h2 className='benefits-headline'>
                      Why Business Owners Love 9 Lives
                    </h2>
                    <p className='benefits-subheadline'>
                      More than $2M in new revenue generated, zero risk, and a
                      process so simple you'll wonder why you didn't start
                      sooner.
                    </p>
                    <ul className='benefits-list'>
                      <li>
                        ✅ Meet Mr. Meowgi, Your AI Reactivation Assistant
                      </li>
                      <li>✅ The 9L Method: Proven Lead Revival System</li>
                      <li>✅ Zero Risk, All Reward—That's Our Guarantee</li>
                      <li>✅ Bank-Level Security for Your Data</li>
                      <li>✅ Works Across All Major Industries</li>
                    </ul>
                    <a href='tel:9546968605' className='cta-btn'>
                      Book a Free Demo
                    </a>
                  </div>
                </div>
              </section>

              {/* Services Section */}
              <Section id='services' title='Services' />
              {/* Social Proof
              <section className='social-proof'>
                <h2>What Our Clients Say</h2>
                <div className='testimonials'>
                  <div className='testimonial'>
                    <p>
                      "Within two weeks, we booked 17 new appointments from leads we
                      thought were dead. Zero risk, all reward!"
                    </p>
                    <span>— Jane D., Medspa Owner</span>
                  </div>
                  <div className='testimonial'>
                    <p>
                      "We saw a 10x ROI in the first month. The process was hands-off
                      and seamless."
                    </p>
                    <span>— Mike R., Solar Company</span>
                  </div>
                  <div className='testimonial'>
                    <p>
                      "Our old leads turned into $50k in new business in 30 days. Highly
                      recommend!"
                    </p>
                    <span>— Sarah T., Real Estate Broker</span>
                  </div>
                </div>
              </section> */}

              {/* Regular Marquee Section */}
              <div className='marquee-container'>
                <div className='marquee'>
                  <div className='marquee-content'>
                    {[...Array(10)].map((_, i) => (
                      <span className='giant-title-row' key={i}>
                        <span className='giant-black'>9</span>
                        <span className='giant-outline'>LIVES</span>
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              {/* FAQ */}
              <section className='faq'>
                <div className='faq-flex'>
                  <div className='faq-content'>
                    <h2>Frequently Asked Questions</h2>
                    <CollapsibleFAQ />
                  </div>
                  <div className='faq-image-col'>
                    <img src={catImg} alt='Mr. Meowgi' className='faq-image' />
                  </div>
                </div>
              </section>

              {/* Contact Form */}
              <section className='contact' id='contact'>
                <div className='contact-inner'>
                  <div className='contact-title'>
                    <div className='giant-title-row contact-giant-title'>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          lineHeight: 1,
                        }}
                      >
                        <span className='giant-black'>STILL HAVE</span>
                        <span
                          className='giant-outline'
                          style={{ fontSize: "1.1em" }}
                        >
                          QUESTIONS?
                        </span>
                      </div>
                      <p
                        style={{
                          marginTop: "18px",
                          fontSize: "1.2rem",
                          color: "#444",
                          maxWidth: "400px",
                          lineHeight: "1.4",
                          textAlign: "left",
                        }}
                      >
                        Don't worry—our team (and our AI cat, Mr. Meowgi) is
                        ready to help.
                      </p>
                    </div>
                  </div>
                  <form>
                    <input type='text' placeholder='Name' required />
                    <input type='email' placeholder='Email' required />
                    <input type='text' placeholder='Company' />
                    <textarea placeholder='Message' rows='4' required />
                    <button type='submit' className='cta-btn'>
                      BOOK YOUR FREE DEMO
                    </button>
                  </form>
                </div>
              </section>

              {/* Roadmap Section */}
              <RoadmapSection />

              {/* Footer */}
              <Footer />
            </div>
          }
        />
        <Route path='/more-services' element={<MoreServicesPage />} />
      </Routes>
    </Router>
  );
}

// Collapsible FAQ component
function CollapsibleFAQ() {
  const faqs = [
    {
      q: "Is there any risk or upfront cost?",
      a: "No Risk, All Reward—That's the 9L Guarantee. You only pay for booked appointments that actually show up on your calendar. If we don't deliver, you don't pay. Simple as that. (No contracts, no setup fees, no cat-and-mouse games.)",
    },
    {
      q: "How do you keep my data secure?",
      a: "Mission: Protect Your Data. Your info is locked up tighter than a cat in a sunbeam. We use 256-bit encryption, strict privacy protocols, and never share your leads. Only our proprietary 9-Lives Engine gets access—your secrets are safe.",
    },
    {
      q: "What types of businesses do you work with?",
      a: "If You've Got Leads, We've Got Your Back. From solar to medspa, dental to real estate, coaching to home services—if you have a list of old leads, our 9L Method will revive them. (And if you're not sure, just ask. We love a challenge.)",
    },
    {
      q: "How fast can I see results?",
      a: "Faster Than a Cat on a Laser Pointer. Most clients see booked appointments in 7-14 days. Give us your coldest leads, and watch us bring them back to life—fast.",
    },
    {
      q: "What if my leads are really old?",
      a: "No Lead Too Cold for 9 Lives. Our proprietary reactivation sequences are designed to revive even the dustiest, long-forgotten leads. If it once had a pulse, we can bring it back.",
    },
  ];
  const [open, setOpen] = React.useState(null);
  return (
    <div className='faq-list'>
      {faqs.map((item, i) => (
        <div className='faq-item' key={i}>
          <button
            className='faq-question-btn'
            onClick={() => setOpen(open === i ? null : i)}
            aria-expanded={open === i}
            aria-controls={`faq-answer-${i}`}
          >
            <span>{item.q}</span>
            <span
              className='faq-arrow'
              style={{
                transform: open === i ? "rotate(90deg)" : "rotate(0deg)",
              }}
            >
              &#9654;
            </span>
          </button>
          <div
            id={`faq-answer-${i}`}
            className='faq-answer'
            style={{
              maxHeight: open === i ? "400px" : "0",
              opacity: open === i ? 1 : 0,
              transition:
                "max-height 0.4s cubic-bezier(.4,2,.6,1), opacity 0.3s",
              overflow: "hidden",
              marginTop: open === i ? "8px" : "0",
            }}
          >
            <p style={{ margin: 0 }}>{item.a}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

// Simple carousel for benefits images
function BenefitsCarousel() {
  const images = [
    { src: teamImg, alt: "Team Visual" },
    // { src: catDock, alt: "Cat Dock" },
  ];

  const [index, setIndex] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 3500);
    return () => clearInterval(interval);
  }, [images.length]);

  // Add safety check for undefined images
  if (!images[index] || !images[index].src) {
    return null;
  }

  return (
    <img
      src={images[index].src}
      alt={images[index].alt}
      className='benefits-image'
      style={{ transition: "opacity 0.7s cubic-bezier(.4,2,.6,1)" }}
    />
  );
}

export default App;
